// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-d2f9b2f6] .itemLink{display:flex;justify-content:flex-end}[data-v-d2f9b2f6] .itemLink>div{display:flex;margin-left:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
